import { Color17ck47lkedxoy as Color } from '../../models/Paint.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_fillPaint(_this__u8e3s4, value) {
  var tmp;
  if (value instanceof Color()) {
    tmp = value.paz();
  } else {
    tmp = value.bb2().paz();
  }
  _this__u8e3s4.fillStyle = tmp;
}
function get_width(_this__u8e3s4) {
  return _this__u8e3s4.canvas.width;
}
function get_height(_this__u8e3s4) {
  return _this__u8e3s4.canvas.height;
}
//region block: exports
export {
  set_fillPaint as set_fillPaint17d1uil08islv,
  get_height as get_height2o8bnqi51rulq,
  get_width as get_width2jz337ntc0974,
};
//endregion

//# sourceMappingURL=DrawingContext2D.js.mjs.map
